import React from 'react';
import { arrayOf, shape, string, number } from 'prop-types';
import { required, email } from 'redux-form-validators';
import { Form, Input, Select, TextArea } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';


const General = ({ organizatioTypesByItem }) => (
    <Section name="General">
        <Form.Group>
            <FormField
                control={Input}
                name="name"
                label="Name"
                placeholder="Name"
                required
                validate={required()}
            />

            <FormField
                control={Select}
                name="organization_type_id"
                label="Type"
                placeholder="Type"
                options={organizatioTypesByItem}
                required
                validate={required()}
            />
        </Form.Group>

        <FormField
            control={Input}
            name="vanity"
            label="Vanity"
            placeholder="Vanity"
        />

        <FormField
            control={Input}
            name="duns"
            label="DUNS"
            placeholder="DUNS"
        />

        <FormField
            control={TextArea}
            name="description"
            label="Description"
            placeholder="Description"
            autoHeight
        />

        <FormField
            control={Input}
            name="url"
            label="Website"
            placeholder="URL"
        />

        <FormField
            control={Input}
            name="phone"
            label="Phone number"
            placeholder="(xxx) xxx-xxxx"
        />

        <FormField
            control={Input}
            name="office_name"
            label="Main Office Name"
            placeholder="Main Office Name"
        />

        <FormField
            control={Input}
            name="email"
            label="Main Office Email"
            placeholder="Main Office Email"
            validate={email()}
        />
    </Section>
);

General.propTypes = {
    organizatioTypesByItem: arrayOf(shape({
        key: number.isRequired,
        value: number.isRequired,
        text: string.isRequired,
    }).isRequired).isRequired,
};

export default General;
